import { Select } from "antd";
import React from "react";
import { Form } from "react-bootstrap";

const medicalConditions = [
  { value: "", label: "Select a condition" },
  { value: "low-bp", label: "Low Blood Pressure" },
  { value: "heart-issues", label: "Heart Issues" },
  { value: "pregnancy", label: "Pregnancy" },
  { value: "breastfeeding", label: "Breastfeeding" },
  { value: "sinus-issues", label: "Sinus Issues" },
  { value: "asthma", label: "Asthma" },
  { value: "anaemia", label: "Anaemia" },
  { value: "low-thyroid", label: "Low Thyroid" },
  { value: "liver-cirrhosis", label: "Liver Cirrhosis" },
  { value: "blood-disorders", label: "Blood Disorders" },
  { value: "epilepsy", label: "Epilepsy" },
  { value: "history-of-stroke", label: "History of Stroke" },
  { value: "other-heart-issues", label: "Other Heart Issues" },
  { value: "other", label: "Other" },
];

function LeadSlotProbeQuestion({ formData, setFormData }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  return (
    <div className="d-flex flex-column gap-1 mt-2">
      <Form.Group className="mb-1" controlId="exampleForm.ControlTextarea1">
        <Form.Label>Are there any ongoing treatments?</Form.Label>
        <Form.Control
          as="textarea"
          name="ongoing_treatment"
          rows={2}
          onChange={handleChange}
        />
      </Form.Group>
      <Form.Group className="mb-1" controlId="exampleForm.ControlTextarea1">
        <Form.Label>
          Do you have any allergies to medications or substances?
        </Form.Label>
        <Form.Control
          as="textarea"
          name="medication_allergy"
          rows={2}
          onChange={handleChange}
        />
      </Form.Group>
      <Form.Group className="mb-1" controlId="exampleForm.ControlTextarea1">
        <Form.Label>Have you used Minoxidil before?</Form.Label>
        <Form.Control
          as="textarea"
          name="minoxidil_info"
          rows={2}
          onChange={handleChange}
        />
      </Form.Group>
      <Form.Group className="mb-1" controlId="exampleForm.ControlTextarea1">
        <Form.Label>Have you undergone any past hair treatments?</Form.Label>
        <Form.Control
          as="textarea"
          name="past_hair_treatment"
          rows={2}
          onChange={handleChange}
        />
      </Form.Group>
      <label for="medical-conditions">
        Do you have any medical conditions?
      </label>
      <Select
        mode="multiple"
        allowClear
        style={{ width: "100%" }}
        placeholder="Do you have any medical conditions?"
        onChange={(value) =>
          setFormData((prev) => ({ ...prev, medical_condition: value }))
        }
        options={medicalConditions}
      />
      {formData?.medical_condition &&
        formData?.medical_condition.includes("other") && (
          <Form.Group className="mb-1" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Please Enter What is other issue.</Form.Label>
            <Form.Control
              as="textarea"
              name="other_issue"
              rows={2}
              onChange={handleChange}
            />
          </Form.Group>
        )}
    </div>
  );
}

export default LeadSlotProbeQuestion;
